module.exports = __webpack_public_path__ + "static/media/upload_more.9cc05c6e.svg";